<template>
  <div class="toggles">
    <div class="toggle" v-for="(option, idx) in options" >
      <input
        :key="option.value"
        :checked="option.value === value"
        :value="option.value"
        :id="option.value"
        type="radio"
        :name="radioGroupID"
        @change="$emit('change', $event.target.value)"
      >
      <label class="cm-button" :for="option.value" :key="`${option.value}-label`">{{ option.label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    options: {
      type: Array
    }
  },

  computed: {
    radioGroupID() {
      return this.name || crypto.randomUUID()
    }
  }
}
</script>

<style lang="scss" scoped>
  .toggles {
    background: var(--bg-2);
    border-radius: 2rem;
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    padding: 0.5rem;
    width: max-content;
    @include min-width($bp_huge) {
      gap: 0;
      width: 100%;
    }
  }

  input {
    opacity: 0;
    position: absolute;
    &:focus-visible + label{
      outline: 5px auto Highlight;
    }

    &:checked + label {
      background: var(--fg);
      color: var(--bg);
    }
  }

  label {
    @include b1;
    background: none;
    color: var(--fg);
    &:hover {
      color: var(--bg);
    }
  }
</style>



// WEBPACK FOOTER //
// app/javascript/components/toggle.vue?97813228